import List from './List';
import Edit from './Edit';
import Show from './Show';

export default {
  name: 'revenue_adjustments',
  list: List,
  edit: Edit,
  show: Show,
  options: {
    group: 'Billing',
    label: 'Revenue Adjustments',
  },
};
